import React from 'react';
import TemplateComponent, {TemplateComponentProps} from "../../containers/template_page/template_component/template_component";
import NavigationSliderII from "../navigation_slider_ii/navigation_slider_ii";
import {CardsListData, NavigationCardData} from "../../model/navigation_slider_data";
import {Col, Container, Row} from "react-bootstrap";
import LuissButton from "../../common_components/luiss_button/luiss_button";
import "./c36_discover_cards.scss";
import {columnLayout} from "../../utils/device";
import {insertHtml} from "../../utils/dom";

interface C36DiscoverCardsData extends CardsListData<NavigationCardData> {
    left_title: string;
    left_subtitle: string;
    left_url: string;
    left_label: string;
}

/**
 * The component 36 Discover Cards is always rendered on a single column layout;
 * it shows a list of cards after a title and a subtitle on the right, and a title, a subtitle and a button on the left
 */
class C36DiscoverCards extends TemplateComponent<C36DiscoverCardsData, TemplateComponentProps<C36DiscoverCardsData>> {

    componentRender(data: C36DiscoverCardsData): React.ReactElement<any> {

        return (
            <Container fluid={true} className="c36-discover-cards">
                <Row>
                    <Col {...columnLayout(5)}>
                        <div className="discover-left-content">
                            <h1 className="title">{data.left_title}</h1>
                            {data.left_subtitle &&
                                <p className="subtitle" {...insertHtml(data.left_subtitle)} />
                            }
                            <LuissButton url={data.left_url}>{data.left_label}</LuissButton>
                        </div>
                    </Col>
                    <Col {...columnLayout(7)}>
                        <NavigationSliderII data={data} layoutColumns={this.props.layoutColumns} language={this.props.language}/>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default C36DiscoverCards;
